import { TableDateCell } from '../../Table'

function EmailTableRowDateUpdated({ item, ...restProps }) {
  const { unread, updated } = item

  return <TableDateCell {...restProps} unread={unread} value={updated} />
}

export default EmailTableRowDateUpdated
